module.exports = __webpack_public_path__ + "img/p-sec01-img06.40373aec.png";